// import LoginPage from './auth/LoginPage.vue'
// import SignupPage from './auth/SignupPage.vue'

const components = {
  // CustomLoginPage: LoginPage,
  // CustomSignupPage: SignupPage,
}

export default components
